import { Upload } from 'lucide-react'
import { useCallback, useState } from 'react'

const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/gif']
const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB

interface FileDropZoneProps {
    fileInputRef: React.RefObject<HTMLInputElement | null>
    onFiles: (files: FileList | File[]) => void
    onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
}

/** Validates and filters files by type and size before passing to parent */
const validateFiles = (fileList: FileList | File[]): File[] => {
    return Array.from(fileList).filter(
        (f) => ACCEPTED_TYPES.includes(f.type) && f.size <= MAX_FILE_SIZE
    )
}

const FileDropZone = ({
    fileInputRef,
    onFiles,
    onSelect,
}: FileDropZoneProps) => {
    const [isDragOver, setIsDragOver] = useState(false)

    const handleDrop = useCallback(
        (e: React.DragEvent) => {
            e.preventDefault()
            setIsDragOver(false)
            const valid = validateFiles(e.dataTransfer.files)
            if (valid.length > 0) onFiles(valid)
        },
        [onFiles]
    )

    return (
        <div
            onDrop={handleDrop}
            onDragOver={(e) => {
                e.preventDefault()
                setIsDragOver(true)
            }}
            onDragLeave={() => setIsDragOver(false)}
            onClick={() => fileInputRef.current?.click()}
            className={`flex flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed p-8 cursor-pointer transition-colors ${
                isDragOver
                    ? 'border-primary bg-primary/5'
                    : 'border-muted-foreground/25 hover:border-primary/50'
            }`}
        >
            <Upload className="h-8 w-8 text-muted-foreground" />
            <div className="text-center">
                <p className="text-sm font-medium">
                    Kéo thả hoặc nhấn để chọn ảnh
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                    JPEG, PNG, GIF - Max 10MB
                </p>
            </div>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/png,image/gif"
                multiple
                onChange={onSelect}
                className="hidden"
            />
        </div>
    )
}

export default FileDropZone
